import React from 'react';
import './style.scss';

export const Navbar = ({ title }) => (
  <nav>
    <a href={'/'}>
      <img src={'/logo.svg'} className={'logo'} />
    </a>
  </nav>
);
